import { render, staticRenderFns } from "./addWorkLvScore.vue?vue&type=template&id=37ece92e&"
import script from "./addWorkLvScore.vue?vue&type=script&lang=js&"
export * from "./addWorkLvScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports